<template>
	<div class="pt-2">
		<CommonFlame :title="title" :maxWidth="'auto'">
			<v-row no-gutters justify="end">
				<v-btn class="mt-2 ml-2" @click="submitForm('draft')" color="secondary">
					<v-icon class="mr-1">mdi-content-save-outline</v-icon>
					上書き保存
				</v-btn>
				<v-btn class="mt-2 ml-2" 
				:disabled="!valid"
				@click="submitForm('confirmation_pending')" color="secondary">
					<v-icon class="mr-1">mdi-content-save-all-outline</v-icon>
					別名保存
				</v-btn>
			</v-row>

			<v-form v-model="valid" ref="form">
				<CheckSheetTemplateForm :check_sheet_template.sync="check_sheet_template" />
			</v-form>
		</CommonFlame>
	</div>
</template>

<script>
import axios from "axios"
import moment from "moment"
import authenticate from "../../helper/authenticate"
import errorHandling from "../../helper/errorHandling"
import common from "../../helper/common"
import CommonFlame from "../shared/CommonFlame.vue"
import CheckSheetTemplateForm from "./components/CheckSheetTemplateForm.vue"

export default {
	components: {
		CommonFlame,
		CheckSheetTemplateForm,
	},
	data() {
		return {
			title: "チェックシートテンプレート編集",
			id: this.$route.params.id,
			check_sheet_template: {
				check_items_attributes: [],
			},
			valid: false,
		}
	},
	methods: {
		fetchCheckSheetTemplate() {
			const headers = authenticate.setHeader()
			const url = `/erp/v1/check_sheet_templates/${this.id}/edit`
			axios
				.get(url, {
					headers,
				})
				.then((res) => {
					// TODO
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		updateCheckSheetTemplate(status) {
			// TODO:
			const headers = authenticate.setHeader()
			const url = `/erp/v1/check_sheet_templates`
			let params = {
				check_sheet_template: {
					status,
					...this.check_sheet_template,
				},
			}
			axios
				.post(url, params, {
					headers,
				})
				.then((res) => {
					// TODO: 状態によって遷移先を変える
					this.$router.push({ name: "check_sheet_template_index" })
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
	},
}
</script>
